<template>
  <div>
    <div v-show="item[field]">
      <b-img v-if="item[field]" rounded="rounded" :src="item[field]" style="width: auto; height: auto; max-width: 100px; max-height: 100px;" blank-color="#777" alt="img" class="m-1" /><br>
      <b-button size="sm" v-b-modal="'modalUploadImage' + field">
        <translate>Change</translate>
      </b-button>
      <b-button size="sm" variant="danger" @click.stop="deleteDocumentImage(field)">
        <font-awesome-icon icon="trash-alt" size="2x" style="font-size: 16px;vertical-align: middle" />
      </b-button>
    </div>
    <div v-show="!item[field]">
      <b-button size="sm" v-b-modal="'modalUploadImage' + field" v-translate>Upload Image</b-button>
    </div>
    <b-modal :id="'modalUploadImage' + field" :ref="'modalUploadImage' + field" hide-footer>
      <template #modal-title>
        <translate>Add a new document image</translate>
      </template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <profile-picture-uploader @updateProfileImage="updateDocumentImage" />
    </b-modal>
  </div>
</template>

<script>
import ProfilePictureUploader from '@/components/ProfilePictureUploader'

export default {
  emits: ['update'],
  name: 'EditFieldImageUpload',
  components: {
    ProfilePictureUploader
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    field: {
      type: String,
      required: true
    }
  },
  methods: {
    updateDocumentImage(url) {
      this.item[this.field] = url
      this.$emit('update', this.item)
      this.$refs['modalUploadImage' + this.field].hide()
    },
    deleteDocumentImage(documentField) {
      if (confirm(this.$gettext('Are you sure you want to DELETE this document picture?'))) {
        this.item[documentField] = null
        this.$emit('update', this.item)
      }
    }
  }
}
</script>
